import React from "react";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";

class ReportesMain extends React.Component {
  ModuleName = "Reportes";
  constructor(props) {
    super(props);
    this.state = {
      selectedView: "",
    };
  }

  selectReports = {
    select: {
      type: "text",
      name: "reporte",
      label: "Reporte: ",
      cols: 5,
      render: (me) => {
        me.innerHTML = `<option value="">Seleccione</option>`;
        this.state.vistasInfo.vistas_info.forEach((s) => {
          let isSelected = (this.state.selectedView && this.state.selectedView === s.vista) ? 'selected' : '';
          me.innerHTML += `<option value="${s.vista}" ${isSelected}>${s.reporte_descripcion}</option>`;
        });
      },
      onchange: (a) => {
        this.setState({ ...this.state, selectedView: a.target.value });
        this.updateForm();
      },
    },
  };

  buttonSearch = {
    button: {
      name: "buscar",
      type: "button",
      class: "form-control btn-orange",
      icon: "fa fa-search",
      cols: 1,
      text: "",
      click: (e) => {
        this.updateGrid();
      },
    },
  };

  buttonExport = {
    button: {
      name: "exportar",
      type: "button",
      class: "form-control btn-green",
      icon: "fa fa-file-download",
      cols: 1,
      text: "",
      click: (e) => {
        this.exportGrid();
      },
    },
  };

  startForm() {
    let formElements = [this.selectReports];
    this.setState({ ...this.state, formElements: formElements });
    let mi_form = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: this.state.formElements,
    });
    this.setState({ ...this.state, mainForm: mi_form });
  }

  updateForm() {
    if (!this.state.selectedView) {
      return;
    }
    let viewInfo = this.state.vistasInfo.vistas_info.filter(
      (o) => o.vista === this.state.selectedView
    );
    this.setState({ ...this.state, filters: viewInfo[0].filtros });
    this.setState({ ...this.state, columns: viewInfo[0].columnas });
    this.updateFilters();
  }

  updateFilters() {
    let newFiltersArray = [];
    //let vistasValue = this.selectReports.value;
    newFiltersArray.push(this.selectReports);
    this.state.filters.forEach((f) => {
      let filterType = "text";
      if (f.filtro_descripcion.toLowerCase().indexOf("fecha") !== -1) {
        filterType = "date";
        newFiltersArray.push({
          input: {
            type: filterType,
            // name: "filter_" + f.filtro_id,f.filtro_descripcion
            name: f.filtro_descripcion + "_start",
            label: f.filtro_descripcion + " Inicio:",
            cols: 2,
            value: "",
          },
        });
        newFiltersArray.push({
          input: {
            type: filterType,
            // name: "filter_" + f.filtro_id,f.filtro_descripcion
            name: f.filtro_descripcion + "_end",
            label: f.filtro_descripcion + " Fin:",
            cols: 2,
            value: "",
          },
        });
      } else {
        newFiltersArray.push({
          input: {
            type: filterType,
            // name: "filter_" + f.filtro_id,f.filtro_descripcion
            name: f.filtro_descripcion,
            label: f.filtro_descripcion + ":",
            cols: 2,
            value: "",
          },
        });
      }
    });
    newFiltersArray.push(this.buttonSearch);
    newFiltersArray.push(this.buttonExport);
    this.setState({ ...this.state, formElements: newFiltersArray });
    let form = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: newFiltersArray
    });
    this.setState({ ...this.state, mainForm: form });
  }

  updateGrid() {
    let rows = {};
    this.state.columns.forEach((c) => {
      rows[c] = {label: c.replaceAll("_", " ")}
    });
    let grid = {
      source: "app/getVistaInfo",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: rows
    };
    this.setState({ searchRecords: this.state.mainForm.data() });
    let search = this.state.searchRecords;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    let handleGrid = Api.grid(grid);
    this.setState({ ...this.state, mainGrid: handleGrid });
    this.state.mainGrid.go(1, src);
  }

  exportGrid() {
    let src = Api.url + "app/getVistaInfo?export=1";
    this.setState({ searchRecords: this.state.mainForm.data() });
    let search = this.state.searchRecords;
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    let w = window.open(src);
  }

  componentDidMount() {
    Api.loading(true);
    Api.fetch("cat/getVistas")
      .then((data) => {
        this.setState({ ...this.state, vistasInfo: data });
        this.startForm();
      })
      .then(() => {
        Api.loading(false);
      });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Inicio</li>
          <li className="breadcrumb-item active">{this.ModuleName}</li>
        </ol>
        <h1 className="page-header">{this.ModuleName}</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default ReportesMain;
